import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterDynamicElement } from "@givebutter/widgets-core";
//#region src/components/GivebutterWidget.tsx
const GivebutterWidget = createLitComponent({
	elementClass: GivebutterDynamicElement,
	tagName: "givebutter-widget"
});
//#endregion
export { GivebutterWidget };
